import type { CSSProperties } from 'react';
import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { DRAWER_HEADER_CLASSNAME } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const listingsControls = css`
  .${DRAWER_HEADER_CLASSNAME} {
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding: ${spacing.xl}px ${spacing.md}px ${spacing.xl}px ${spacing.md}px;

    button {
      margin: 0;
    }
  }
`;

export const list = css`
  margin: 0 0 40px 0;
  padding: 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0;
    `,
  )};
`;

export const listItem = css`
  padding-right: ${spacing.md}px;
`;

export const separator = css`
  margin: 0 ${spacing.sm}px;
  border: none;
  background-color: var(--neutral-black-10);
  height: 1px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0;
    `,
  )};
`;

export interface BorderCSS extends CSSProperties {
  '--borderColor': string;
}

export const facetOptionsWrapper = css`
  padding: ${spacing.sm}px 0 0 ${spacing.sm}px;
  font-weight: 600;
  border-left: 3px solid var(--borderColor);

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${spacing.sm}px 0 0 0;
      border-left: none;
    `,
  )};
`;

export const facetOptionsAccordionWrapper = css`
  padding: 0 0 0 ${spacing.sm}px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0;
    `,
  )};
`;
